import "core-js/modules/es6.promise";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.search";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.find-index";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import debounce from 'lodash/debounce';
import { cloneDeep } from 'lodash';
export default {
  name: 'CustomMultiSearch',
  props: {
    dense: {
      type: Boolean,
      default: false,
      required: false
    },
    searchTypes: {
      type: Array,
      required: true
    },
    searchItems: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    singleSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultSearchType: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    showOperatorDropdown: {
      type: Boolean,
      required: false,
      default: false
    },
    operator: {
      type: String,
      required: false,
      default: 'AND'
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      modelSearchType: '',
      modelSearchFor: '',
      modelSearchKey: '',
      searchTags: [],
      searchOperator: this.operator,
      customSearchInput: '',
      customSearchResult: [],
      customSearchResultLoading: false,
      customSearchSelectedItemCopy: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    disableAddSearch: function disableAddSearch() {
      return !(this.modelSearchType !== '' && this.modelSearchFor !== '');
    },
    cols: function cols() {
      var hasKey = this.modelSearchType.param === 'keyValue';
      return {
        category: {
          cols: hasKey ? 4 : 6,
          md: hasKey ? 4 : 2,
          lg: 3
        },
        keyBox: {
          cols: hasKey ? 3 : 0,
          md: hasKey ? 4 : 0,
          lg: hasKey ? 2 : 0
        },
        searchBox: {
          cols: hasKey ? 5 : 6,
          md: hasKey ? 4 : 6,
          lg: hasKey ? 3 : 4
        },
        displayBox: {
          cols: 12,
          md: hasKey ? 12 : 4,
          lg: hasKey ? 4 : 5
        }
      };
    },
    searchOperators: function searchOperators() {
      return [{
        text: this.$i18n_t('Common.searchOperator.AND'),
        param: 'AND'
      }, {
        text: this.$i18n_t('Common.searchOperator.OR'),
        param: 'OR'
      }];
    },
    useCustomSearch: function useCustomSearch() {
      var searchHandlerType = _typeof(this.modelSearchType.searchHandler);

      return searchHandlerType === 'function';
    },
    customSearchResultWithSelected: function customSearchResultWithSelected() {
      var items = cloneDeep(this.customSearchResult);

      if (this.customSearchSelectedItemCopy) {
        items.push(this.customSearchSelectedItemCopy);
      } // unique by id


      return items.filter(function (item, index, self) {
        return self.findIndex(function (t) {
          return t.id === item.id;
        }) === index;
      });
    }
  }),
  watch: {
    searchTypes: function searchTypes() {
      var store = this.modelSearchType.param;
      this.modelSearchType = this.searchTypes.find(function (item) {
        return item.param === store;
      }) || {};
    },
    searchItems: function searchItems() {
      this.searchTags = this.searchItems;
    },
    operator: function operator() {
      var _this = this;

      this.searchOperator = this.searchOperators.filter(function (item) {
        return item.param === _this.operator;
      })[0] || {};
    },
    customSearchInput: {
      immediate: true,
      handler: function handler() {
        this.executeCustomSearch();
      }
    },
    modelSearchFor: function modelSearchFor(value) {
      if (this.useCustomSearch) {
        this.customSearchSelectedItemCopy = cloneDeep(value);
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.searchTags = this.searchItems;
    this.modelSearchType = isEmpty(this.defaultSearchType) ? '' : this.defaultSearchType;

    if (this.searchOperators.length > 0) {
      this.searchOperator = this.searchOperators.filter(function (item) {
        return item.param === _this2.operator;
      })[0] || {};
    }
  },
  methods: {
    executeCustomSearch: debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.useCustomSearch) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              this.customSearchResultLoading = true;
              _context.prev = 3;
              _context.next = 6;
              return this.modelSearchType.searchHandler(this.customSearchInput);

            case 6:
              this.customSearchResult = _context.sent;
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
              console.error(_context.t0);
              this.$snack(this.$i18n_t('Common.multisearch.customSearch.error'), 'error');

            case 13:
              _context.prev = 13;
              this.customSearchResultLoading = false;
              return _context.finish(13);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[3, 9, 13, 16]]);
    })), 300),
    updateSearchType: function updateSearchType() {
      this.modelSearchFor = '';
      this.modelSearchKey = '';
    },
    searchKeyUpEnter: function searchKeyUpEnter() {
      if (!this.disableAddSearch) {
        this.searchAdd();
      }
    },
    parentTwinSelected: function parentTwinSelected(parentTwin) {
      this.modelSearchFor = parentTwin ? {
        value: parentTwin.id,
        text: parentTwin.title
      } : undefined;
      this.searchAdd();
    },
    searchRemove: function searchRemove(searchItemIndex) {
      this.searchTags.splice(searchItemIndex, 1);
      this.updateSearchType();
      this.$emit('updated', this.searchTags, this.searchOperator.param);
    },
    searchOperatorUpdate: function searchOperatorUpdate() {
      this.searchTags.splice(0, this.searchTags.length);
      this.updateSearchType();
      this.$emit('updated', this.searchTags, this.searchOperator.param);
    },
    searchAdd: function searchAdd() {
      var type = this.modelSearchType.text;
      var param = this.modelSearchType.param; // make sure that >null< is supported and not written as string "null" via `${text}`.trim()

      var searchForText = (this.modelSearchFor || {}).text !== undefined ? this.modelSearchFor.text : this.modelSearchFor;
      searchForText = searchForText === null ? searchForText : "".concat(searchForText).trim();
      var search = (this.modelSearchFor || {}).text ? {
        value: this.modelSearchFor.value,
        text: searchForText
      } : searchForText; // If the to be added search already exists in `searchTags` ignore it

      var index = this.searchTags.findIndex(function (item) {
        return item.param === param && item.search === search;
      });

      if (index > -1) {
        this.updateSearchType();
        return;
      }

      var key = param === 'keyValue' ? "".concat(this.modelSearchKey).trim() : undefined;
      this.searchTags.push({
        type: type,
        param: param,
        search: search,
        key: key
      });
      this.updateSearchType();
      this.$emit('updated', this.searchTags, this.searchOperator.param);
    }
  }
};